import { render } from "./fl-footer.vue?vue&type=template&id=2c70c794&scoped=true"
import script from "./fl-footer.vue?vue&type=script&lang=js"
export * from "./fl-footer.vue?vue&type=script&lang=js"

import "./fl-footer.vue?vue&type=style&index=0&id=2c70c794&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c70c794"]])

export default __exports__